<template>
    <AppSubmenu
        class="layout-menu sebrae-sidebar__menu"
        :items="model"
        :layoutMode="layoutMode"
        :menuActive="active"
        :mobileMenuActive="mobileMenuActive"
        :root="true"
        :parentMenuItemActive="true"
        @menuitem-click="$emit('menuitem-click', $event)"
        @root-menuitem-click="$emit('root-menuitem-click', $event)"
    />
</template>

<script>
import AppSubmenu from './AppSubmenu';

export default {
    props: {
        model: Array,
        layoutMode: String,
        active: Boolean,
        mobileMenuActive: Boolean,
    },
    emits: ['menuitem-click', 'root-menuitem-click'],
    components: {
        AppSubmenu,
    },
};
</script>
